import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CourseCompletionModal({ isOpen, courseName, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleDashboard = () => {
    navigate('/dashboard');
  };

  const handleReviewCourse = () => {
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'var(--overlay-bg)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-5)',
        }}
        onClick={onClose}
      >
        {/* Modal */}
        <div
          style={{
            background: 'var(--bg-elevated)',
            borderRadius: 'var(--radius-overlay)',
            padding: 32,
            maxWidth: 420,
            width: '100%',
            textAlign: 'center',
            border: '1px solid var(--border-subtle)',
            boxShadow: 'var(--shadow-lg)',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Success icon */}
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: 'var(--success)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
            }}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--text-inverted)"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          {/* Title */}
          <h2
            style={{
              margin: '0 0 12px',
              fontSize: 24,
              fontWeight: 700,
              color: 'var(--text-primary)',
              lineHeight: 1.3,
            }}
          >
            Congratulations!
          </h2>

          {/* Subtitle */}
          <p
            style={{
              margin: '0 0 32px',
              fontSize: 16,
              color: 'var(--text-secondary)',
              lineHeight: 1.5,
            }}
          >
            You've completed{' '}
            <span style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
              {courseName || 'this course'}
            </span>
          </p>

          {/* Buttons */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
            }}
          >
            <button
              type="button"
              onClick={handleDashboard}
              style={{
                width: '100%',
                padding: '14px 24px',
                fontSize: 15,
                fontWeight: 600,
                borderRadius: 'var(--radius-panel)',
                background: 'var(--text-primary)',
                color: 'var(--bg-primary)',
                border: 'none',
                cursor: 'pointer',
                transition: 'opacity 0.15s ease',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.opacity = '0.85';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
            >
              Back to Dashboard
            </button>
            <button
              type="button"
              onClick={handleReviewCourse}
              style={{
                width: '100%',
                padding: '14px 24px',
                fontSize: 15,
                fontWeight: 500,
                borderRadius: 'var(--radius-panel)',
                background: 'transparent',
                color: 'var(--text-secondary)',
                border: '1px solid var(--border-subtle)',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'var(--bg-tertiary)';
                e.currentTarget.style.color = 'var(--text-primary)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'var(--text-secondary)';
              }}
            >
              Review Course Material
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
